import moment from 'moment-timezone';
import { isWorkoutOnDateInTimezone } from 'fitbeat.gym-core';
import { BookingState } from 'fitbeat.models';
import { getGymTimezone } from './gyms';

export const hasConfirmedSingleAndPartnerBookingOnDay = (bookings, day) => {
  return bookings.some((booking) => {
    if (booking.bookingState !== BookingState.ConfirmedBooking) {
      return false;
    }

    const isSingleBookingConfirmed = (
      booking.pairedSession === undefined &&
      booking.bookingState === BookingState.ConfirmedBooking
    );

    const hasPairedBookingAndConfirmed = (
      booking.pairedSession !== undefined &&
      booking.pairedSession.bookingState === BookingState.ConfirmedBooking
    );

    const isBookingOnDay = isWorkoutOnDateInTimezone(day, booking, getGymTimezone);
    return ((isBookingOnDay) && ((
      isSingleBookingConfirmed && !hasPairedBookingAndConfirmed)
      || (hasPairedBookingAndConfirmed)));
  });
};

export const hasInviteForDayOrUnconfirmedPairedBooking = (bookings, day) => {
  return bookings.some((booking) => {
    const hasPairedBookingAndNotAccepted = (
      booking.pairedSession !== undefined &&
      booking.pairedSession.bookingState !== BookingState.ConfirmedBooking
    );

    let isExpired = false;
    if (booking.pairedSession && booking.expiresAt) {
      isExpired = moment(booking.expiresAt).isBefore(moment());
    }

    const isBookingOnDay = isWorkoutOnDateInTimezone(day, booking, getGymTimezone);
    return ((!isExpired && isBookingOnDay)
      && ((booking.bookingState === BookingState.BookingInvite)
      || (hasPairedBookingAndNotAccepted)));
  });
};

export const filterInvitesForDay = (bookings, day) => {
  const filteredInvites = bookings.filter((booking) => {
    const isExpired = moment(booking.expiresAt).isBefore(moment());
    return isWorkoutOnDateInTimezone(day, booking, getGymTimezone) &&
      !isExpired &&
      booking.bookingState === BookingState.BookingInvite;
  });

  return filteredInvites;
};

export const filterWaitingListForDay = (waitingList, day) => {
  const filteredWaitingList = waitingList.find(waitlistEntry =>
    isWorkoutOnDateInTimezone(day, {
      ...waitlistEntry.timeSlot,
      gymName: waitlistEntry.gymName
    }, getGymTimezone),
  );

  return filteredWaitingList;
};
